import { Chip, Tooltip, Zoom } from "@mui/material";

interface Props {
  carrierSharees?: CarrierBookingSharee[];
}

export function BookingOwnerChip(props: Props) {
  const { carrierSharees } = props;

  if (
    !carrierSharees ||
    carrierSharees.length === 0 ||
    !carrierSharees[0]?.shared_by?.user?.first_name ||
    carrierSharees[0].shared_by.user.first_name.length < 1 ||
    carrierSharees[0].shared_by.user.last_name.length < 1
  ) {
    return null;
  }

  const sharedBy = carrierSharees[0].shared_by;

  const chip = (
    <Chip
      label={`${sharedBy.user.first_name[0]}.${sharedBy.user.last_name[0]}.`}
      size="medium"
      color="primary"
      variant="outlined"
    />
  );

  return (
    <Tooltip
      title={`${sharedBy.user.first_name || ""} ${sharedBy.user.last_name || ""}`}
      placement="right"
      TransitionComponent={Zoom}
    >
      {chip}
    </Tooltip>
  );
}
